import actions from '../../../constants/actionTypes';
import request from '../../../utils/request';
import { startAppLoading, stopAppLoading } from '../../../layout/actions';
import { isSuccess, removeParamsForServer } from '../../../utils/utils';
import {
  setGeneralError,
  setGeneralSuccess,
} from '../../../layout/components/UniversalModal/actions';
import { trans } from '../../../localization/index';
import { closeDialogGeneric } from '../../../redux/genericAction';
import { EnumPage } from '../../../constants/enum';

export function closeUserWalletRestaurant() {
  return {
    type: actions.CLOSE_USER_WALLET_RESTAURANT_MODAL,
  };
}

export function openUpdateUserWallet(airpayStoreId, walletItem) {
  return {
    type: actions.OPEN_UPDATE_USER_WALLET_MODAL,
    response: {
      airpayStoreId,
      walletItem,
    },
  };
}

export function openCreateUserWallet() {
  return {
    type: actions.OPEN_CREATE_USER_WALLET_MODAL,
  };
}

export function openAddRestaurantUserWallet() {
  return {
    type: actions.OPEN_ADD_RESTAURANT_USER_WALLET_MODAL,
  };
}

export function closeAddRestaurantUserWallet() {
  return {
    type: actions.CLOSE_ADD_RESTAURANT_USER_WALLET,
  };
}

export function setToggleOpenActiveEmail(
  isOpenDialog,
  email = '',
  title = trans('merchant_wallet_update_success'),
) {
  return {
    type: actions.SET_TOGGLE_OPEN_ACTIVE_EMAIL_MODAL,
    response: {
      isOpenDialog,
      email,
      title,
    },
  };
}

export function changeTableActivePageWalletRestaurant(activePage) {
  return {
    type: actions.CHANGE_TABLE_ACTIVE_PAGE_WALLET_RESTAURANT,
    response: {
      activePage,
    },
  };
}

export function changeTablePageSizeWalletRestaurant(pageSize) {
  return {
    type: actions.CHANGE_TABLE_PAGE_SIZE_WALLET_RESTAURANT,
    response: {
      pageSize,
    },
  };
}

export function getListUserWallet() {
  return dispatch => {
    dispatch(startAppLoading());
    return request
      .getMerchant('/api/wallet/get_user_wallets')
      .then(response => {
        if (isSuccess(response)) {
          const { wallets: itemList = [] } = response.reply;
          dispatch({
            type: actions.RECEIVE_LIST_USER_WALLET,
            response: {
              itemList,
              totalSize: itemList.length,
            },
          });
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function getListUserWalletRestaurant(airpayStoreId) {
  return dispatch => {
    dispatch(startAppLoading());
    const body = {
      airpay_store_ids: [airpayStoreId],
    };
    return request
      .postMerchant('/api/wallet/get_restaurants', body)
      .then(response => {
        if (isSuccess(response)) {
          const {
            restaurant_mappings: restaurantMappings = [],
          } = response.reply;
          const { restaurants: itemList = [] } = restaurantMappings[0] || {};
          dispatch({
            type: actions.RECEIVE_USER_WALLET_RESTAURANT,
            response: {
              itemList,
              airpayStoreId,
            },
          });
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function getUnLinkedRestaurant() {
  return dispatch => {
    dispatch(startAppLoading());
    return request
      .getMerchant('/api/wallet/get_unlinked_restaurants')
      .then(response => {
        if (isSuccess(response)) {
          const { restaurants: unlinkedRestaurants = [] } = response.reply;
          dispatch({
            type: actions.RECEIVE_LIST_UNLINKED_RESTAURANT,
            response: {
              unlinkedRestaurants,
            },
          });
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function createUserWallet(reqParam) {
  const requestData = removeParamsForServer(reqParam, '');
  return dispatch => {
    dispatch(startAppLoading());
    return request
      .postMerchant('/api/wallet/register', requestData)
      .then(response => {
        if (isSuccess(response)) {
          dispatch(closeDialogGeneric(EnumPage.WALLET_MANAGEMENT.id));
          dispatch(getListUserWallet());
          dispatch(
            setToggleOpenActiveEmail(
              true,
              reqParam.owner_email,
              trans('rebranding.merchant_wallet_create_success'),
            ),
          );
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function updateUserWallet(reqParam) {
  const requestData = removeParamsForServer(reqParam, '');

  return (dispatch, getState) => {
    const {
      owner_email: ownerEmail,
      status,
    } = getState().wallet.userWallet.dialog.walletItem;
    // Only airpay_store_id
    if (Object.keys(requestData).length === 1) {
      dispatch(setGeneralError(trans('merchant_wallet_update_no_data_change')));
      return null;
    }
    dispatch(startAppLoading());
    return request
      .postMerchant('/api/wallet/update', requestData)
      .then(response => {
        if (isSuccess(response)) {
          dispatch(getListUserWallet()).then(() => {
            dispatch(
              setGeneralSuccess(trans('merchant_wallet_update_success')),
            );
          });
        } else if (response.result === 'error_wallet_pending_update') {
          dispatch(getListUserWallet()).then(() => {
            const receiveEmail =
              (status === 0 && reqParam.owner_email) || ownerEmail;
            dispatch(setToggleOpenActiveEmail(true, receiveEmail));
          });
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function resendActivationEmailUserWallet(airpayStoreId, ownerEmail) {
  return dispatch => {
    dispatch(startAppLoading());
    const reqParam = {
      airpay_store_id: airpayStoreId,
    };
    return request
      .postMerchant('/api/wallet/resend_activation_email', reqParam)
      .then(response => {
        if (isSuccess(response)) {
          dispatch(
            setToggleOpenActiveEmail(
              true,
              ownerEmail,
              trans('merchant_wallet_activation_email_success'),
            ),
          );
        } else {
          dispatch(setGeneralSuccess(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function addRestaurantUserWallet(reqParam) {
  const requestData = removeParamsForServer(reqParam, '');
  return dispatch => {
    dispatch(startAppLoading());
    return request
      .postMerchant('/api/wallet/link_restaurant', requestData)
      .then(response => {
        if (isSuccess(response)) {
          dispatch(getListUserWalletRestaurant(reqParam.airpay_store_id));
          dispatch(
            setGeneralSuccess(trans('merchant_wallet_link_restaurant_success')),
          );
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function removeRestaurantUserWallet(reqParam) {
  return dispatch => {
    dispatch(startAppLoading());
    return request
      .postMerchant('/api/wallet/unlink_restaurant', reqParam)
      .then(response => {
        if (isSuccess(response)) {
          dispatch(getListUserWalletRestaurant(reqParam.airpay_store_id));
          dispatch(
            setGeneralSuccess(
              trans('merchant_wallet_unlink_restaurant_success'),
            ),
          );
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/actions.js